import { PermissionAction, PermissionSubject } from '@workspace/permissions';

export const permissionElements = {
	// pages
	adminDictionaryPage: ['read_list_of_dictionaries', 'dictionary'],
	adminSelectionPage: ['read_list', 'selection'],
	adminBusinessProcessPage: ['read_list', 'business_process'],
	adminCertificatesPage: ['read_list', 'certificate_template'],
	adminNotificationTemplatePage: ['read_list', 'notification_template'],
	adminRoadmapTemplatePage: ['read_list', 'roadmap_template'],
	adminCollegialPage: ['update', 'collegial'],
	adminRolePage: ['read_list', 'role'],
	adminProjectTemplatePage: ['read_list', 'project_template'],
	adminCriteriaPage: ['read_list', 'criteria'],
	adminConsentPage: ['read_list', 'consent'],
	adminTutorialPage: ['read', 'tutorial'],
    evaluationPage: ['read', 'evaluation'],
	expertsListPage: ['read_list', 'expert'],
	expertiseArchiveListPage: ['read', 'evaluation'],
	expertiseCurrentListPage: ['read', 'evaluation'],
	expertiseNewListPage: ['read', 'evaluation'],
	userProfileUpdatePage: ['update', 'user'],
	manageUserRoles: ['manage_roles', 'user'],
	projectsListPage: ['read_list', 'project'],
	partnersListPage: ['read_list', 'partner'],
	projectEditPage: ['update', 'project'],
	projectAuditPage: ['read', 'audit'],
	projectAuditUpdatePage: ['update', 'audit'],
	projectEvaluationPage: ['read', 'evaluation'],
	projectHistoryPage: ['read', 'project_changes_log'],
	projectPassportPage: ['read', 'project_passport'],
	projectRequestPage: ['read', 'project'],
	projectRoadmapPage: ['read', 'roadmap'],
	projectStatusPage: ['read', 'project_status_log'],
	projectUploadPage: ['manage', 'all'],
	
	readTaskStatusReport: ['read_task_status', 'report'],
	exportTaskStatusReport: ['export_task_status', 'report'],
	readProjectsActivityReport: ['read_projects_activity', 'report'],
	exportProjectsActivityReport: ['export_projects_activity', 'report'],
	readMonitoringResultsReport: ['read_monitoring_results', 'report'],
	exportMonitoringResultsReport: ['export_monitoring_results', 'report'],
	readStatusSelectionsReport: ['read_status_selections', 'report'],
	readCalendarReport: ['read_calendar', 'report'],

	selectionsPage: ['read_list', 'selection'],
	usersListPage: ['read_list', 'user'],
	draftsPage: ['read', 'project_draft'],
	personalAccountApplicationsPage: ['read', 'project'],
	personalAccountCertificatesPage: ['read', 'certificate'],
	personalAccountConsentsPage: ['read_list', 'consent'],
	personalAccountEvaluationsPage: ['read', 'evaluation'],
	personalAccountMeetingsPage: ['read_list', 'collegial'],
	personalAccountProfilePage: ['read', 'user'],
	personalAccountProjectsPage: ['read', 'project'],
	personalAccountTemplatesPage: ['read', 'user'], // ?
	formProjectCreate: ['create', 'project'],
	formProjectCreateDraft: ['create', 'project_draft'],

	personalAccountCompetenciesRead: ['read', 'expert'],
	personalAccountCompetenciesUpdate: ['update', 'expert'],
	
	importProjectsPage: ['read_list', 'import_projects'],

	// subjects
	adminDictionaryLink: ['read_list_of_dictionaries', 'dictionary'],
	adminSelectionLink: ['read_list', 'selection'],
	adminBusinessProcessLink: ['read_list', 'business_process'],
	adminCertificatesLink: ['read_list', 'certificate_template'],
	adminNotificationTemplateLink: ['read_list', 'notification_template'],
	adminRoadmapTemplateLink: ['read_list', 'roadmap_template'],
	adminCollegialLink: ['update', 'collegial'],
	adminRoleLink: ['read_list', 'role'],
	adminProjectTemplateLink: ['read_list', 'project_template'],
	adminCriteriaLink: ['read_list', 'criteria'],
	adminConsentLink: ['read_list', 'consent'],
    adminFtsLink: ['read_list', 'notification_template'],

	collegialReadLink: ['read', 'collegial'],
	collegialVotingPage: ['read', 'collegial'],
	collegialVotingAdminPage: ['update', 'collegial'],
	collegialCreateButton: ['create', 'collegial'],
	collegialUpdateButton: ['update', 'collegial'],
	collegialDeleteButton: ['delete', 'collegial'],

	businessProcessCreateButton: ['create', 'business_process'],
	businessProcessReadLink: ['read', 'business_process'],
	businessProcessDuplicateButton: ['create', 'business_process'],
	businessProcessUpdateButton: ['update', 'business_process'],
	businessProcessDeleteButton: ['delete', 'business_process'],
	businessProcessAuthorLink: ['read', 'user'],

	certificateTemplateCreateButton: ['create', 'certificate_template'],
	certificateTemplateCreateMailingButton: ['mailing', 'certificate_template'],
	certificateTemplateReadLink: ['read', 'certificate_template'],
	certificateTemplateDuplicateButton: ['create', 'certificate_template'],
	certificateTemplateDeleteButton: ['delete', 'certificate_template'],
	certificateTemplateUpdateButton: ['update', 'certificate_template'],
	certificateTemplateUpdateBackgroundButton: ['update_background', 'certificate_template'],
	certificateTemplateDeleteBackgroundButton: ['delete_background', 'certificate_template'],
	certificateTemplateAuthorLink: ['read', 'user'],
	certificateTemplatePreview: ['preview', 'certificate_template'],

	certificateUserUpdate: ['update', 'certificate'],
	certificateUserPreview: ['preview', 'certificate'],

	consentCreateButton: ['create', 'consent'],
	consentAuthorLink: ['read', 'user'],
	usersConsents: ['read_user_consent', 'consent'],
	usersConsentsDelete: ['remove_user_data', 'consent'],

	criteriaReadLink: ['read', 'criteria'],
	criteriaCreateButton: ['create', 'criteria'],
	criteriaDuplicateButton: ['create', 'criteria'],
	criteriaUpdateButton: ['update', 'criteria'],
	criteriaDeleteButton: ['delete', 'criteria'],
	criteriaAuthorLink: ['read', 'user'],

	dictionaryElementCreateButton: ['create_element', 'dictionary'],
	dictionaryElementDuplicateButton: ['create_element', 'dictionary'],
	dictionaryElementUpdateButton: ['update_element', 'dictionary'],
	dictionaryElementDeleteButton: ['delete_element', 'dictionary'],
	dictionaryElementsLink: ['read_list', 'dictionary'],
	dictionaryAuthorLink: ['read', 'user'],
	dictionaryElementStats: ['read_stats', 'dictionary'],

	notificationTemplateCreateButton: ['create', 'notification_template'],
	notificationTemplateReadLink: ['read', 'notification_template'],
	notificationTemplateDuplicateButton: ['create', 'notification_template'],
	notificationTemplateUpdateButton: ['update', 'notification_template'],
	notificationTemplateDeleteButton: ['delete', 'notification_template'],
	notificationTemplateAuthorLink: ['read', 'user'],

	projectTemplateCreateButton: ['create', 'project_template'],
	projectTemplateDuplicateButton: ['create', 'project_template'],
	projectTemplateUpdateButton: ['update', 'project_template'],
	projectTemplateDeleteButton: ['delete', 'project_template'],
	projectTemplateAuthorLink: ['read', 'user'],

	roadmapTemplateReadLink: ['read', 'roadmap_template'],
	roadmapTemplateCreateButton: ['create', 'roadmap_template'],
	roadmapTemplateDuplicateButton: ['create', 'roadmap_template'],
	roadmapTemplateUpdateButton: ['update', 'roadmap_template'],
	// TODO
	// roadmapTemplateDeleteButton: ['delete', 'roadmap_template'],
	roadmapTemplateAuthorLink: ['read', 'user'],

	// Roadmap document
	// View
	roadmapDocumentViewScan: ['view_scan', 'roadmap_document'],
	roadmapDocumentViewConsent: ['view_consent', 'roadmap_document'],
	roadmapDocumentViewOther: ['view_other', 'roadmap_document'],
	// Upload
	roadmapDocumentUploadScan: ['upload_scan', 'roadmap_document'],
	roadmapDocumentUploadConsent: ['upload_consent', 'roadmap_document'],
	roadmapDocumentUploadOther: ['upload_other', 'roadmap_document'],
	// Delete
	roadmapDocumentDeleteScan: ['delete_scan', 'roadmap_document'],
	roadmapDocumentDeleteConsent: ['delete_consent', 'roadmap_document'],
	roadmapDocumentDeleteOther: ['delete_other', 'roadmap_document'],
	// Replace
	roadmapDocumentReplaceScan: ['replace_scan', 'roadmap_document'],
	roadmapDocumentReplaceConsent: ['replace_consent', 'roadmap_document'],
	roadmapDocumentReplaceOther: ['replace_other', 'roadmap_document'],
	// Update
	roadmapDocumentUpdateScan: ['update_scan', 'roadmap_document'],
	roadmapDocumentUpdateConsent: ['update_consent', 'roadmap_document'],
	roadmapDocumentUpdateOther: ['update_other', 'roadmap_document'],

	roleReadLink: ['read', 'role'],
	roleCreateButton: ['create', 'role'],
	roleDuplicateButton: ['create', 'role'],
	roleUpdateButton: ['update', 'role'],
	roleDeleteButton: ['delete', 'role'],

	selectionCreateButton: ['create', 'selection'],
	selectionReadLink: ['read', 'selection'],
	selectionDuplicateButton: ['create', 'selection'],
	selectionUpdateButton: ['update', 'selection'],
	selectionDeleteButton: ['delete', 'selection'],
	selectionAuthorLink: ['read', 'user'],
	selectionClose: ['close', 'selection'],
	selectionExport: ['read', 'selection'],

	auditUpdateButton: ['update', 'audit'],
	auditUpdateCompletedButton: ['update_completed', 'audit'],
	expertiseExpertListDownloadButton: ['export', 'expert'],
	expertiseCreateModal: ['create', 'evaluation'],
	expertiseCreateButton: ['create', 'evaluation'],
	changeOperatorButton: ['change_operator', 'head_tracker'],
	expertiseWorkflow: ['work', 'evaluation'],
	expertiseCriterias: ['read', 'criteria'],

	projectPageDownloadApplicationButton: ['export', 'project'],
	projectPageDownloadRoadmapButton: ['export', 'roadmap'],
	projectPageDownloadPassportButton: ['export', 'project_passport'],
	projectPageDownloadCapApplications: ['project_first_level_criteria', 'project'],
	projectPageSaveRoadmapAsTemplateButton: ['create', 'roadmap_template'],
	projectPageCloneProjectButton: ['create', 'project'],
	projectPageUpdateButton: ['update', 'project'],
	draftProjectUpdateButton: ['update', 'draft_project'],
	projectPageUpdateRightsButton: ['update_rights', 'project'],
	projectPageUpdateTags: ['update_tags', 'project'],

	projectPageRoadmapCreate: ['create', 'roadmap'],
	projectPageRoadmapUpdate: ['update', 'roadmap'],
	projectPageRoadmapView: ['read', 'roadmap'],

	projectPageRoadmapTaskRead: ['read', 'roadmap_task'],
	projectPageRoadmapTaskCreate: ['create', 'roadmap_task'],
	projectPageRoadmapTaskUpdate: ['update', 'roadmap_task'],
	projectPageRoadmapTaskFinish: ['finish', 'roadmap_task'],
	projectPageRoadmapTaskDelete: ['delete', 'roadmap_task'],

	projectPagePassportCreate: ['create', 'project_passport'],
	projectPagePassportUpdate: ['update', 'project_passport'],
	projectPagePassportView: ['read', 'project_passport'],

	projectPageExpertiseView: ['read', 'evaluation'],

	projectPageStatusTabView: ['read', 'project_status_log'],
	projectPageHistoryTabView: ['read', 'project_changes_log'],
	projectPageStatusProtocolEdit: ['update_protocol', 'project_status_log'],

	projectPageQuickEdit: ['quick_edit', 'project'],

	projectUpdateTracker: ['update_tracker', 'project'],
	projectUpdateOperator: ['update_operator', 'project'],

	projectsCreateButton: ['create', 'project'],
	projectsExportButton: ['export', 'project'],
	projectsReadRecommendation: ['read_recommendation', 'project'],
	projectsMultipleUpdate: ['quick_edit', 'project'],
	projectsActualSelections: ['read_actual_list', 'selection'],
	projectsPassportTab: ['read', 'project_passport'],

	projectStatusLogProtocolDownload: ['download_protocol', 'project_status_log'],

	auditCreateButton: ['create', 'audit'],
	auditUpdate: ['update', 'audit'],

	expertExpertiseExportButton: ['export', 'evaluation'],
	expertExpertiseStatistic: ['read', 'evaluation'],
	expertiseRemind: ['remind', 'evaluation'],
	expertiseCancel: ['cancel', 'evaluation'],
	expertiseChangeCompletionDate: ['change_completion_date', 'evaluation'],
	expertiseCompletedUpdate: ['update', 'evaluation'],

	updateExpertiseButton: ['update', 'evaluation'],

	collegialViewAdminMode: ['read_voting_results', 'collegial'],
	collegialView: ['read', 'collegial'],
	collegialHistory: ['read_logs', 'collegial'],
	collegialGenerateProtocol: ['generate_protocol', 'collegial'],
	collegialDeleteProtocol: ['delete_protocol', 'collegial'],
	collegialThirdPartyVoting: ['third_party_voting', 'collegial'],
	collegialChangeMeetingStatus: ['change_meeting_status', 'collegial'],
	collegialSubscribeToVotingResults: ['subscribe_to_voting_results', 'collegial'],

	partnerRead: ['read', 'partner'],
	partnerCreate: ['create', 'partner'],
	partnerUpdate: ['update', 'partner'],
	partnerDelete: ['delete', 'partner'],
	
	importProjectsRead: ['read', 'import_projects'],
	importProjects: ['import', 'import_projects'],

	tutorialRead: ['read', 'tutorial'],
	tutorialCreate: ['create', 'tutorial'],
	tutorialUpdate: ['update', 'tutorial'],
	tutorialDelete: ['delete', 'tutorial'],

	revertProjectStatus: ['delete', 'project'],

	authorLink: ['read', 'user'],

    // invites
    personalAccountInvitesPage: ['read', 'project'],

    revokeInvite: ['revoke', 'invite'],
    inviteOther: ['invite_other', 'invite'],
    inviteLeader: ['invite_leader', 'invite'],
    invitePartner: ['invite_partner', 'invite'],
    inviteTeamMember: ['invite_team_member', 'invite'],

    // approvements
    personalAccountApprovementsPage: ['read', 'project'],

	all: ['manage', 'all'],
} as const;
export type TYPE_CONST = PermissionAction | PermissionSubject;
// } satisfies Record<string, [PermissionAction, PermissionSubject]>;

export type PermissionElement = keyof typeof permissionElements;
